import React from "react";
import "./home.css";
import Product from "./Product";
import sqlguide from "./image/sqlguide.jpg";

function Home() {
  return (
    <div className="home">
      <div className="home_container">
        <img
          className="home_image"
          src="/images/background.jpg"
          alt="Banner"
        />
        <div className="home_row">
          <Product
            id="111111"
            title="SQL QuickStart Guide"
            price={29.99}
            image="https://images-na.ssl-images-amazon.com/images/I/61T3GCJfygL._AC_UL160_SR160,160_.jpg"
            rating={5}
          />
          <Product
            id="111112"
            title="A Common-Sense Guide to Data Structures and Algorithms, Second Edition: Level Up Your Core Programming Skills"
            price={29.99}
            image="https://images-na.ssl-images-amazon.com/images/I/81HW8lmRduL._AC_UL160_SR160,160_.jpg"
            rating={4}
          />
        </div>
        <div className="home_row">
          <Product
            id="111113"
            title="Ace the Data Science Interview: 201 Real Interview Questions Asked By FAANG, Tech Startups, & Wall Street"
            price={32.4}
            image="https://images-na.ssl-images-amazon.com/images/I/61q1IqrlhyL._AC_UL160_SR160,160_.jpg"
            rating={4}
          />
          <Product
            id="111114"
            title="The lean startup"
            price={29.99}
            image={sqlguide}
          />
          <Product
            id="111115"
            title="The lean startup"
            price={29.99}
            image={sqlguide}
          />
        </div>
        <div className="home_row">
          <Product
            id="111116"
            title="The lean startup"
            price={29.99}
            image={sqlguide}
          />
        </div>
      </div>
    </div>
  );
}

export default Home;
